import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { OrganisationService } from './organisation.service';
import { Observable, of } from 'rxjs';
import { IOrganisation } from '@bciti/types';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { Module } from '@bciti/types';

@Injectable({ providedIn: 'root' })
export class OrganisationServiceImpl implements OrganisationService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    getAvailableModules() {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) =>
                this.http
                    .get(`${env.baseUrl}/cerberus/configurations/modules`, {
                        headers: { 'x-organisation': 'ALL' },
                    })
                    .pipe(map((x) => x as { modules: Module[] })),
            ),
        );
    }

    getOrganisations(): Observable<IOrganisation[]> {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) =>
                this.http.get<IOrganisation[]>(`${env.baseUrl}/cerberus/organisations`).pipe(
                    map((Organisation) => Organisation.sort((a, b) => (a.name > b.name ? 1 : -1))),
                    tap((_) => this.log('Configs Fetched')),
                    catchError(this.handleError<IOrganisation[]>('getOrganisations', [])),
                ),
            ),
        );
    }

    getOrganisationByTag(tag: string): Observable<IOrganisation> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/organisation/${tag}`).pipe(map((org) => org as IOrganisation))));
    }

    uploadLogo(file: any): Observable<string> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/onboarding/fileupload/temp`).pipe(map((url) => url as string))));
    }

    updateOrganisation(tag: string, organisation: IOrganisation): Observable<IOrganisation> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.patch(`${env.baseUrl}/cerberus/organisations/${tag}`, organisation).pipe(map((org) => org as IOrganisation))));
    }

    private log(message: string) {
        // this.messageService.add(`Configurations : ${message}`);
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}

export const ORGANISATION_SERVICE = {
    provide: OrganisationService,
    useClass: OrganisationServiceImpl,
};
